import { useQuery } from '@tanstack/react-query';

import { listShiftTypes } from '@/api/shift-type-api';

const SHIFT_TYPES_KEY = ['shift-types'] as const;

/**
 * Lists every shift type configured on the realm. The wizard's
 * `ShiftTypeSelect` and the landing's colour key both consume this.
 *
 * Returns the flat list; consumers that need the parent/child tree
 * call `sortShiftTypesIntoTree` from `@/api/shift-type-api`.
 */
export function useShiftTypes() {
  return useQuery({
    queryKey: SHIFT_TYPES_KEY,
    queryFn: () => listShiftTypes(),
  });
}
